import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FileUtilsService } from '../../../_helpers/file-utils.service';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ProcessService } from '../../../_services/process.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig } from '../../../_helpers/index';
import { Router } from '@angular/router';
import { CreationBatch, StatusBatch, TypeBatch } from '../../../_enums/batches';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DatePipe, formatDate } from '@angular/common';
import { ConfigurationService, PayoutService } from '../../../_services/index';
import * as fs from 'file-saver';
import * as moment from 'moment';

@Component({
  selector: 'batches',
  templateUrl: './batches.component.html',
  styleUrls: ['../../../../assets/css/customer-list-table.css']
})
export class BatchesListComponent implements OnInit {

  public customer_public_id: string;
  excelExportData: any;
  ddldbdocumenttype: any[];
  importDisable: boolean = true;
  auth0Profile: any;
  searchFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'name', 'user', 'type', 'status', 'statusColor', 'actions'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  pageSize: number;
  PageSizeOptions: number[];
  isLoading = true;
  isadmin = false;
  paginatorIntl: any;
  ddlCreation: any[];
  creationStatus: any[];
  createType: any[];
  isRangoStatus = "None";
  isRangoVisiable = false;
  searchRangoFilterForm: FormGroup;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  isAction = true;
  kashioApplication: any;
  batchDetails: any = [];
  userName: string = "";
  startDate = "All";
  endDate = "All";
  batchesList = [];
  status: any = "All";
  type: any = "All";
  configuration: any;
  configurationStatus: any;

  @Input() messageTitle: string;

  constructor
    (
      private processService: ProcessService, private formBuilder: FormBuilder
      , private router: Router, protected creation: CreationBatch
      , protected statusBatch: StatusBatch
      , protected typeBatch: TypeBatch
      , private spinnerService: Ng4LoadingSpinnerService,
      private _fb: FormBuilder
      , private datePipe: DatePipe
      , private configurationService: ConfigurationService
      , private payoutService: PayoutService
      , public fileUtilsService: FileUtilsService
    ) {
    this.spinnerService.show();
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.isadmin = false;
  }//end cons

  applyFilter() {
    this.filter();
  }

  ngOnInit() {

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      let browserStorageAdmin = localStorage.getItem('isadmin');

      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }

      if (browserStorageAdmin == 'true') {

        this.isadmin = true;
      }
      else {

        this.isadmin = false;
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 30;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    this.kashioApplication = localStorage.getItem('application');
    this.isRangoVisiable = false;
    this.ddlCreation = this.creation._creation;
    this.creationStatus = this.statusBatch._status;
    this.createType = this.typeBatch._type;
    this.GetProcessDetails();
    this.GetConfigList();
    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  GetConfigList() {
    if (this.kashioApplication !== 'PAYOUTS') {
      this.configurationService.getConfigurationList(this.customer_public_id, 'KBATCH').subscribe(data => {
        this.configuration = data;
        
        if (this.configuration.data.length > 0) {
          if (this.configuration.data[0].status != undefined) {
            this.configurationStatus = this.configuration.data[0].status;
          }
        }
        // if (data.status == '200') {
        //   this.importDisable = false;
        // }
        // else {
        //   this.importDisable = true;
        // }
      },
        error => {
          this.importDisable = true;
          console.log('Failed! while trying to get the configuration details. ' + error.error);
        });
    }
    if (this.kashioApplication === 'PAYOUTS') {
      this.payoutService.getPayoutConfiguration(this.customer_public_id).subscribe(data => {
        this.configuration = data;
        if (this.configuration.status != undefined) {
          if (this.configuration.status == 'ACTIVE') {
            this.importDisable = false;
          }
          if (this.configuration.status == 'INACTIVE') {
            this.importDisable = true;
          }
        } else {
          this.importDisable = true;
        }
      }, error => {
        this.importDisable = true;
        console.log('Failed! while trying to get the payout import template details. ' + error.error);
      })
    }
  }


  GetProcessDetails() {
    this.processService.getProcessNew(this.customer_public_id).subscribe(data => {
      this.isLoading = false;
      let resources = data["data"];

      //metadata.user.name is string format
      resources.forEach(element => {
        console.log(element);
        if (element.metadata.user != undefined && element.metadata.user.name != undefined) {
          if (element.metadata.user.name == "undefined") {
            element.metadata.user.name = undefined;
          }
        }
      });

      this.dataSource.data = resources;
      this.batchesList = resources;
      this.spinnerService.hide();
    },
      error => {
        this.isLoading = false;
        console.log('Failed while trying to the Process Search All Result. ' + error.error);
      });
  }//end

  // viewBatchDetails(element) {

  //   location.href = element.storage_url;

  // }//end
  filterCreationDetails(creation) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.startDate = "All";
      this.endDate = "All";
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.startDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.endDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
    }

    // Current Week Filter Condition
    if (creation == 2) {
      var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      this.startDate = this.convertGMTTime(WeekstartDate1);
      this.endDate = this.convertGMTTime(WeekendDate1);
    }

    // Today Filter Condition
    if (creation == 3) {
      currentDate.setDate(currentDate.getDate());
      var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      this.startDate = this.convertGMTTime(todayStartDate);
      var todayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      this.endDate = this.convertGMTTime(todayEndDate);


    }

    // Yesterday Filter Condition
    if (creation == 4) {
      currentDate.setDate(currentDate.getDate() - 1);
      var yesterDayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      this.startDate = this.convertGMTTime(yesterDayStartDate);
      var yesterdayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US'));
      this.endDate = this.convertGMTTime(yesterdayEndDate);

    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.startDate = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.endDate = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.startDate = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.endDate = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
    }
    // Range Filter Condition
    if (creation == 7) {
      this.startDate = "All";
      this.endDate = "All"
      this.isRangoStatus = "creation";
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoStatus = "None";
      this.isRangoVisiable = false;
    }

    if (creation == 8) {
      this.startDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
      this.endDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
    }
    this.filter();
  }//end

  filter() {
    var tempFilterData = this.batchesList;
    if (this.startDate != "All" && this.endDate != "All") {
      if ((this.startDate != undefined && this.startDate != null) && (this.endDate != undefined && this.endDate != null)) {
        tempFilterData = tempFilterData.filter(data => data.created >= this.startDate && data.created <= this.endDate)
      } else {
        tempFilterData = this.batchesList;
      }
    } else {
      tempFilterData = this.batchesList;
    }

    if (this.status != "All") {
      if (this.status == 2) {
        tempFilterData = tempFilterData.filter(data => data.status == 2 || data.status == 3 || data.status == 5)
      } else {
        tempFilterData = tempFilterData.filter(data => data.status == this.status)
      }
    }

    if (this.type != "All") {
      tempFilterData = tempFilterData.filter(data => data.type == this.type)
    }

    if (this.searchFilterForm.controls.searchText.value.length > 0) {
      var serachValue = this.searchFilterForm.controls.searchText.value.trim();
      tempFilterData = tempFilterData.filter(data => data.name.toLowerCase().includes(serachValue.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
    this.paginator.firstPage();
  }

  filterAllDetails() {


    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value !== '' && this.searchRangoFilterForm.controls.searchToDate.value !== ''
    ) {




      if (this.isRangoStatus == "creation") {
        this.filterRangoDetails();
      }
    }
    else {

      this.isRangoVisiable = false;

    }

  }

  filterTypeDetails(type) {
    if (type == 0) {
      this.type = "All";
    } else {
      this.type = type;
    }
    this.filter();
  }

  filterStatusDetails(status) {
    if (status == this.creationStatus[0].value) {
      this.status = "All";
    } else if (status == this.creationStatus[1].value) {
      this.status = 1
    } else if (status == this.creationStatus[2].value) {
      this.status = 2
    } else if (status == this.creationStatus[3].value) {
      this.status = 6
    } else if (status == this.creationStatus[4].value) {
      this.status = 4
    } else {
      this.status = status;
    }
    this.filter();
  }

  filterRangoDetails() {
    if (this.creation._creation.length > 8) {
      this.creation._creation.shift();
    }
    if (this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '') {
      this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
      this.ddlCreation.unshift({ value: 8, name: this.filterValue });
      this.isRangoVisiable = false;
      let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.startDate = this.convertGMTTime(new Date(CurrentmonthFirstDate));
      this.endDate = this.convertGMTTime(new Date(CurrentmonthEndDate));
      this.filter();
    }
  }//end

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  downloadFile(url, name, createdDate?: string) {
    this.spinnerService.show();
    const fileName = this.fileUtilsService.getFileExtension(url);
    const fileNameWithDate = this.fileUtilsService.getCleanName(name, createdDate);
    
    this.processService.downloadfile(url).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob], fileNameWithDate + "." + fileName, { type: res.body.type });
      fs.saveAs(file);
      this.spinnerService.hide();
    }
      ,
      error => {
        console.log('Failed while trying to the download the file. ' + error.error);
      })
  }


  /**
  * this function is used to get the batch details.
  */
  getBatchDetails(batch_id) {
    this.batchDetails = [];
    this.userName = "";
    this.spinnerService.show();
    this.processService.getBatchDetails(batch_id).subscribe(res => {
      // console.log(res);
      this.batchDetails = res;
      //if the total_records value is undefined then set the total_records value is 0
      if (this.batchDetails.total_records === undefined) {
        this.batchDetails['total_records'] = 0;
      }
      this.userName = this.getUserName();
      this.spinnerService.hide();
    }, error => {
      console.log('Failed while trying to get the batch details. ' + error.error);
    })
  }

  /**
  * this function is used to get the username from the batch details.
  */
  getUserName() {
    try {
      if (this.batchDetails.metadata != null && this.batchDetails.metadata != undefined) {
        let metadataJson = JSON.parse(this.batchDetails.metadata)
        return metadataJson.user.name
      }
      return "";
    } catch {
      console.error('No name available in metadata');
      return "";
    }
  }

  getDateMoment(val) {
    var dateForma = moment(val).format("DD/MM/YYYY");
    return dateForma;
  }

  removeT(val) {
    if (val != null && val != undefined) {
      return val.replace('T', ' ')
    }
  }
}
